import { useMutation } from '@tanstack/react-query';

import axios from 'axios';
import { MutationConfig, queryClient } from 'lib/react-query';

import { WeatherWindow, CreateWeatherWindowDto } from 'types';

export const createWeatherWindow = async (
  data: CreateWeatherWindowDto
): Promise<WeatherWindow> => {
  const { data: createdWindow } = await axios.post(
    '/api/weather/windows',
    data
  );
  return createdWindow as WeatherWindow;
};

type UseCreateWeatherWindowOptions = {
  config?: MutationConfig<typeof createWeatherWindow>;
};

export const useCreateWeatherWindow = ({
  config,
}: UseCreateWeatherWindowOptions) => {
  return useMutation({
    onError: (_, __, context: any) => {
      if (context?.previousWeatherWindows) {
        queryClient.setQueryData(
          ['weatherWindows'],
          context.previousWeatherWindows
        );
      }
    },
    onSuccess: (data) => {
      queryClient.invalidateQueries(['weatherWindows']);
      queryClient.invalidateQueries(['weatherWalls', data.weather_wall_id]);
      queryClient.invalidateQueries([
        'weatherWindowLocations',
        data.location_id,
      ]);
    },
    ...config,
    mutationFn: createWeatherWindow,
  });
};
